import React, { useContext, useEffect } from 'react'
import { Modal, Form, Input, Button } from 'antd'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserAdd, canUserSave } from 'utils/User'

const TriggeredMailModal = ({
  visible,
  onCreate,
  onUpdate,
  onCancel,
  isEdit,
  selectedData,
  loading,
}) => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const hasEdit = canUserEdit(userPermissions || currentUser, isClient)
  const hasAdd = canUserAdd(userPermissions || currentUser, isClient)
  const hasSave = canUserSave(userPermissions || currentUser, isClient)
  const canSubmit = isEdit ? (hasEdit && hasSave) : (hasAdd && hasSave)

  const [form] = Form.useForm()

  useEffect(() => {
    if (visible && selectedData) {
      form.setFieldsValue(selectedData)
    } else {
      form.resetFields()
    }
  }, [visible, selectedData, form])

  const handleSubmit = () => {
    if (!canSubmit) return
    form
      .validateFields()
      .then((values) => {
        if (isEdit) {
          onUpdate(values, form.resetFields)
        } else {
          onCreate(values, form.resetFields)
        }
      })
      .catch((info) => console.log('Validate Failed:', info))
  }

  return (
    <Modal
      className='feedback_form'
      maskClosable={false}
      visible={visible}
      centered
      title={isEdit ? 'Edit Triggered Mail' : 'Add Triggered Mail'}
      okText={isEdit ? 'Update Mail' : 'Add Mail'}
      okButtonProps={{ loading, disabled: !canSubmit }}
      cancelText='Cancel'
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      onOk={handleSubmit}
    >
      <Form
        layout='vertical'
        form={form}
        name='triggered_mail_form'
        initialValues={selectedData || {}}
      >
        <Form.Item
          name='triggeredName'
          label='Trigger Name'
          rules={[{ required: true, message: 'Please enter trigger name' }]}
        >
          <Input placeholder='Enter trigger name' />
        </Form.Item>

        <Form.Item
          name='triggeredInterval'
          label='Interval'
          rules={[{ required: true, message: 'Please enter interval in days' }]}
        >
          <Input type='text' placeholder='Enter interval in days' />
        </Form.Item>

        <Form.Item
          name='triggeredType'
          label='Trigger Type'
          rules={[{ required: true, message: 'Please enter trigger type' }]}
        >
          <Input placeholder='Enter trigger type (e.g. mandate)' />
        </Form.Item>
      </Form>

      <div className='footer-btn-div'>
        <Button
          className='footer-cancel-btn'
          onClick={() => {
            form.resetFields()
            onCancel()
          }}
        >
          Cancel
        </Button>
        <Button
          className='footer-submit-btn'
          disabled={!canSubmit}
          onClick={handleSubmit}
          type='primary'
        >
          {isEdit ? 'Update Mail' : 'Add Mail'}
        </Button>
      </div>
    </Modal>
  )
}

export default TriggeredMailModal
